module.exports = __webpack_public_path__ + "img/turn-on.8dab2a6b.svg";